import { Tag } from "antd";
import { getPercentTagColor } from "../../Helper/Methods";
import { replaceValuesWithDash } from "../../unity-ui-common/Methods/Methods";

export const aggregatedReportTypes = [
  {
    value: "segregatedByCountry",
    label: "Segregated by Country",
  },
  {
    value: "segregatedByStudy",
    label: "Segregated by Study",
  },
  {
    value: "segregatedByProduct",
    label: "Segregated by Product",
  },
  {
    value: "segregatedByContactType",
    label: "Segregated by Contact Type",
  },
];

export const reportedWithinDueDateItems = [
  {
    title: "Yes",
    value: 0,
  },
  {
    title: "Not Applicable",
    value: 1,
  },
  {
    title: "No",
    value: 2,
  },
];

export const contactTypeItem = [
  {
    label: "Principal Investigator",
    name: "15",
  },
  {
    label: "Other Site Personnel",
    name: "16",
  },
  {
    label: "Regulatory Authority",
    name: "18",
  },
  {
    label: "Ethics Committee / Institutional Review Board",
    name: "17",
  },
  {
    label: "Partner",
    name: "19",
  },
];
export const distributionListcolumns = [
  {
    title: "Contact Type",
    dataIndex: "role",
    width: 170,
    key: "role",
  },
  {
    title: "Contact Country",
    width: 150,
    dataIndex: "country",
    key: "country",
  },
  {
    title: "Contact Name",
    width: 150,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Reporting Method",
    width: 190,
    dataIndex: "modeOfCorrespondence",
    key: "modeOfCorrespondence",
  },
  {
    title: "Day 0",
    width: 150,
    dataIndex: "irb",
    key: "irb",
  },
  {
    title: "Due Date",
    width: 150,
    dataIndex: "dueDate",
    key: "dueDate",
  },
  {
    title: "Reporting Date/Notification Date",
    width: 280,
    dataIndex: "sentOn",
    key: "sentOn",
  },
  {
    title: "Notified within due date",
    width: 250,
    dataIndex: "reportedWithinDueDate",
    key: "reportedWithinDueDate",
  },
];

export const segregatedContactReportColumns = [
  {
    title: "Contact Name",
    dataIndex: "name",
    key: "name",
    width: 280,
  },
  {
    title: "Contact Type",
    dataIndex: "role",
    key: "role",
    width: 280,

  },
  {
    title: "Email ID",
    dataIndex: "primary_email_id",
    key: "primary_email_id",
    width: 280,
  },
  // {
  //   title: "Site Number",
  //   dataIndex: "site_number",
  //   key: "site_number",
  // },
  // {
  //   title: "Site Name",
  //   dataIndex: "site_name",
  //   key: "site_name",
  // },

  {
    title: "Reporting Method",
    dataIndex: "modeOfCorrespondence",
    key: "modeOfCorrespondence",
    width: 280,
  },
  {
    title: "Contact Country",
    dataIndex: "country",
    key: "country",
    width: 280,
  },
  {
    title: "Number of Safety Documents Shared",
    dataIndex: "totalDocShared",
    key: "totalDocShared",
    width: 280,
    // The Contacts report returns the full result set (no server-side
    // pagination), so client-side sorting on these computed columns operates on
    // all rows. Sort numerically by the count / by the compliance percentage.
    sorter: (a: any, b: any) =>
      (Number(a?.totalDocShared) || 0) - (Number(b?.totalDocShared) || 0),
    render: (data: string) => {
      return data || "-";
    },
  },
  {
    title: "Safety Document Notification Compliance",
    // dataIndex points at the scalar "notified/total" string so the filter
    // dropdown lists real ratio values (same approach as /home). render reads the
    // compliance object off the row; sorter compares the numeric percentage.
    dataIndex: "siteNotificationComplianceRatio",
    key: "siteNotificationComplianceRatio",
    width: 320,
    sorter: (a: any, b: any) =>
      (Number(a?.siteNotificationCompliance?.value) || 0) -
      (Number(b?.siteNotificationCompliance?.value) || 0),
    render: (_ratio: any, record: any) => {
      const data = record?.siteNotificationCompliance;
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
  {
    title: "Acknowledgement Compliance",
    dataIndex: "siteAcknowledgementComplianceRatio",
    key: "siteAcknowledgementComplianceRatio",
    width: 280,
    sorter: (a: any, b: any) =>
      (Number(a?.siteAcknowledgementCompliance?.value) || 0) -
      (Number(b?.siteAcknowledgementCompliance?.value) || 0),
    render: (_ratio: any, record: any) => {
      const data = record?.siteAcknowledgementCompliance;
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
  {
    title: "EC/IRB Notification Compliance",
    dataIndex: "ECIRBNotificationComplianceRatio",
    key: "ECIRBNotificationComplianceRatio",
    width: 280,
    sorter: (a: any, b: any) =>
      (Number(a?.ECIRBNotificationCompliance?.value) || 0) -
      (Number(b?.ECIRBNotificationCompliance?.value) || 0),
    render: (_ratio: any, record: any) => {
      const data = record?.ECIRBNotificationCompliance;
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
];

export const aggregatedContactReportByCountryColumns = [
  {
    title: "Contact Type",
    dataIndex: "role",
    key: "role",
    render: (role: any) => {
      const text = Array.isArray(role) ? (
        <div>
          {role?.map((rol: any) => {
            return <p style={{ margin: "0" }}>{rol}</p>;
          })}
        </div>
      ) : (
        role
      );
      return text;
    },
  },
  {
    title: "Contact Country",
    dataIndex: "country",
    key: "country",
    render: (country: any) => {
      const text = Array.isArray(country) ? country.join(", ") : country;
      return text;
    },
  },
  {
    title: "Study Number",
    dataIndex: "studyId",
    key: "studyId",
    render: (studyId: any) => {
      const text = Array.isArray(studyId)
        ? replaceValuesWithDash(studyId).join(", ")
        : studyId;
      return text;
    },
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: (product: any) => {
      const text = Array.isArray(product)
        ? replaceValuesWithDash(product).join(", ")
        : product;
      return text;
    },
  },

  {
    title: "Number of Safety Documents Shared",
    dataIndex: "totalDocShared",
    key: "totalDocShared",
    width: 280,
    render: (data: string) => {
      return data || "-";
    },
  },
  {
    title: "Safety Document Notification Compliance",
    dataIndex: "safetyDocumentNotificationCompliance",
    key: "safetyDocumentNotificationCompliance",
    width: 280,
    render: (data: any) => {
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
];

export const aggregatedContactReportByStudyColumns = [
  {
    title: "Contact Type",
    dataIndex: "role",
    key: "role",
    render: (role: any) => {
      const text = Array.isArray(role) ? (
        <div>
          {role?.map((rol: any) => {
            return <p style={{ margin: "0" }}>{rol}</p>;
          })}
        </div>
      ) : (
        role
      );
      return text;
    },
  },
  {
    title: "Study Number",
    dataIndex: "studyId",
    key: "studyId",
    render: (studyId: any) => {
      const text = Array.isArray(studyId)
        ? replaceValuesWithDash(studyId).join(", ")
        : studyId;
      return text;
    },
  },
  {
    title: "Contact Country",
    dataIndex: "country",
    key: "country",
    render: (country: any) => {
      const text = Array.isArray(country) ? country.join(", ") : country;
      return text;
    },
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: (product: any) => {
      const text = Array.isArray(product)
        ? replaceValuesWithDash(product).join(", ")
        : product;
      return text;
    },
  },

  {
    title: "Number of Safety Documents Shared",
    dataIndex: "totalDocShared",
    key: "totalDocShared",
    width: 280,
    render: (data: string) => {
      return data || "-";
    },
  },
  {
    title: "Safety Document Notification Compliance",
    dataIndex: "safetyDocumentNotificationCompliance",
    key: "safetyDocumentNotificationCompliance",
    width: 280,
    render: (data: any) => {
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
];

export const aggregatedContactReportByProductColumns = [
  {
    title: "Contact Type",
    dataIndex: "role",
    key: "role",
    render: (role: any) => {
      const text = Array.isArray(role) ? (
        <div>
          {role?.map((rol: any) => {
            return <p style={{ margin: "0" }}>{rol}</p>;
          })}
        </div>
      ) : (
        role
      );
      return text;
    },
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: (product: any) => {
      const text = Array.isArray(product)
        ? replaceValuesWithDash(product).join(", ")
        : product;
      return text;
    },
  },
  {
    title: "Contact Country",
    dataIndex: "country",
    key: "country",
    render: (country: any) => {
      const text = Array.isArray(country) ? country.join(", ") : country;
      return text;
    },
  },
  {
    title: "Study Number",
    dataIndex: "studyId",
    key: "studyId",
    render: (studyId: any) => {
      const text = Array.isArray(studyId)
        ? replaceValuesWithDash(studyId).join(", ")
        : studyId;
      return text;
    },
  },
  {
    title: "Number of Safety Documents Shared",
    dataIndex: "totalDocShared",
    key: "totalDocShared",
    width: 280,
    render: (data: string) => {
      return data || "-";
    },
  },
  {
    title: "Safety Document Notification Compliance",
    dataIndex: "safetyDocumentNotificationCompliance",
    key: "safetyDocumentNotificationCompliance",
    width: 280,
    render: (data: any) => {
      const tagColor = getPercentTagColor(data?.value);
      const percentVal = `${parseFloat(data?.value).toFixed(0)}%`;
      const value = `${String(data?.data)}/${String(data?.total)}`;
      return (
        <>
          <Tag color={tagColor} className="percentTag">
            {percentVal}
          </Tag>
          <span>{value}</span>
        </>
      );
    },
  },
];

export const getAggregatedContactReportColumns = (type: string) => {
  switch (type) {
    case "segregatedByCountry":
      return aggregatedContactReportByCountryColumns;
    case "segregatedByStudy":
      return aggregatedContactReportByStudyColumns;
    case "segregatedByProduct":
      return aggregatedContactReportByProductColumns;
    default:
      return aggregatedContactReportByCountryColumns;
  }
};

export const getAggregatedContactReportColumnsDataName = (type: string) => {
  switch (type) {
    case "segregatedByCountry":
      return "aggregatedContactReportByCountryColumns";
    case "segregatedByStudy":
      return "aggregatedContactReportByStudyColumns";
    case "segregatedByProduct":
      return "aggregatedContactReportByProductColumns";
    default:
      return "aggregatedContactReportByCountryColumns";
  }
};
